import { use } from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import CheckOutStep from '../../Component/CheckOutStep';
import { savePaymentMethod } from '../../redux/actions/cartAction';
import Button from '../../Component/Button/index';

//import './PaymentMethodScreen.less';

export default function PaymentMethodScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);
  const { shippingAddress } = cart;

  //console.log('shippingAddress en PaymentMethodScreen: ', shippingAddress);

  useEffect(() => {
    if (!shippingAddress.address) {
      navigate('/shipping');
    }
  }, [shippingAddress.address]);

  const [paymentMethod, setPaymentMethod] = useState('PayPal');

  const submitHandler = e => {
    e.preventDefault();
    //console.log('paymentMethod: ', paymentMethod);
    dispatch(savePaymentMethod(paymentMethod));
    navigate('/placeorder');
  };

  return (
    <div>
      <CheckOutStep step1 step2 step3></CheckOutStep>
      <form className="form" onSubmit={submitHandler}>
        <div>
          <h1>Payment Method</h1>
        </div>
        <div>
          <div>
            <input
              type="radio"
              id="paypal"
              value="paypal"
              name="paymentMethod"
              required
              checked
              onChange={e => setPaymentMethod(e.target.value)}
            />
            <label htmlFor="paypal">PayPal</label>
          </div>
        </div>
        <div>
          <div>
            <input
              type="radio"
              id="mercadoPago"
              value="mercadoPago"
              name="paymentMethod"
              required
              checked
              onChange={e => setPaymentMethod(e.target.value)}
            />
            <label htmlFor="mercadoPago">Mercado Pago</label>
          </div>
        </div>
        <div>
          {/* <button className="btn" type="submit">
            Continue
          </button> */}
          <Button type="submit"> Continue</Button>
        </div>
      </form>
    </div>
  );
}
